import { API } from "./utils"


export const members = {
  membersList: (params=null) => API.get("/parties/member-collectives/", { params }),
  sisterSocietyAgreementsList: (params=null) => API.get("/parties/sister-society-agreements/", { params }),
}
